import { type BarometerSpecificAreaKey, type BarometerAreaKey } from 'types/surveys';

export const SURVEY_TEMPLATES = {
  HORIZONTAL_OPTIONS: 'HORIZONTAL_OPTIONS',
  VERTICAL_OPTIONS: 'VERTICAL_OPTIONS',
  RADIO_BUTTONS: 'RADIO_BUTTONS',
  TEXT_AREA: 'TEXT_AREA',
} as const;

export const SURVEY_TYPES = {
  DAILY: 'DAILY',
  TEST: 'TEST',
  ASSESSMENT: 'ASSESSMENT',
} as const;

export const BAROMETER_AREAS = {
  GENERAL: 'general',
  EMOTIONAL: 'salud-emocional',
  RELATIONAL: 'salud-relacional',
  PROFESSIONAL: 'realizacion-profesional',
  HEALTH: 'habitos-de-salud',
} as const;

export const BAROMETER_AREA_ORDER: BarometerAreaKey[] = [
  BAROMETER_AREAS.EMOTIONAL,
  BAROMETER_AREAS.PROFESSIONAL,
  BAROMETER_AREAS.RELATIONAL,
  BAROMETER_AREAS.HEALTH,
];

export const AREA_COLORS: Record<BarometerSpecificAreaKey, string> = {
  [BAROMETER_AREAS.EMOTIONAL]: 'var(--color-teal-500)',
  [BAROMETER_AREAS.PROFESSIONAL]: 'var(--color-denim-600)',
  [BAROMETER_AREAS.RELATIONAL]: 'var(--color-pink-600)',
  [BAROMETER_AREAS.HEALTH]: 'var(--color-denim-300)',
};
